import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { Component } from 'react';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
import { I as IconQuestionFilled } from './IconQuestionFilled-146e7ca3.js';

var styles = {"anchor":"TooltipAnchor_anchor__3doHp","anchor-dark":"TooltipAnchor_anchor-dark__NueHf"};

class TooltipAnchor extends Component {
  render() {
    const {
      className,
      ...props
    } = this.props;
    const theme = this.props.theme || this.context && this.context.theme;
    const tooltipAnchorClassName = cx(className, styles.anchor, {
      [styles['anchor-dark']]: theme === 'dark'
    });
    return /*#__PURE__*/React__default.createElement("span", _extends({}, props, {
      className: tooltipAnchorClassName
    }), /*#__PURE__*/React__default.createElement(IconQuestionFilled, null));
  }
}
TooltipAnchor.contextType = ThemeContext;

export default TooltipAnchor;
